// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyByG-VTiidyqMQ3VY6zR2PN2jpVnvw_IDo",
  authDomain: "ibs-wiki.firebaseapp.com",
  projectId: "ibs-wiki",
  storageBucket: "ibs-wiki.firebasestorage.app",
  messagingSenderId: "660769801460",
  appId: "1:660769801460:web:baced36a6487ad06b00aa1",
  measurementId: "G-DZSPDFK658",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

export const auth = getAuth(app);


export { db, analytics };